import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsFieldlinksService } from './edit-dialogs-fieldlinks.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-fieldlinks',
  templateUrl: './edit-dialogs-fieldlinks.component.html',
  styleUrls: ['./edit-dialogs-fieldlinks.component.scss']
})
export class EditDialogsFieldlinksComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsFieldlinksService: EditDialogsFieldlinksService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsFieldlinksComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsFieldlinksService.build(); }

  ngOnInit() {
    this.editDialogsFieldlinksService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el fieldlinks
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsFieldlinksService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del fieldlink está ausente
      // -1: El número del fieldlink ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorFieldlinks('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorFieldlinks('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog fieldlinks
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let fieldlink = this.editDialogsFieldlinksService.fieldlinks;
    let original = this.editDialogsFieldlinksService.originalFieldlinks;
    return this.editDialogsFieldlinksService.compare(fieldlink, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorFieldlinks(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
